import React from 'react';
import { Shield, Zap, Clock } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function OfferBlock() {
  return <section id="offer" className="py-24 px-4 bg-navy-900 relative overflow-hidden" data-id="element-101">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-accent-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-102" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-103">
        <FadeIn data-id="element-104">
          <div className="text-center mb-12" data-id="element-105">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white" data-id="element-106">
              No dejes que otro año pase con el mismo sueldo de siempre.
            </h2>
            <p className="text-xl text-slate-300 max-w-2xl mx-auto" data-id="element-107">
              Mientras el mundo se vuelve remoto, tú sigues atado a la economía
              local. Accede hoy mismo al sistema completo que te sacará de ahí.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-108">
          <div className="bg-navy-800 border-2 border-accent-500/30 rounded-3xl p-8 md:p-12 shadow-[0_0_50px_rgba(34,211,238,0.1)] relative overflow-hidden" data-id="element-109">
            {/* Corner ribbon */}
            <div className="absolute -right-12 top-8 bg-accent-500 text-navy-900 font-bold py-1 px-12 rotate-45 shadow-lg text-sm" data-id="element-110">
              OFERTA ESPECIAL
            </div>

            <div className="text-center mb-10" data-id="element-111">
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-2" data-id="element-112">
                Primer Empleo Remoto: El Kit de Supervivencia
              </h3>
              <div className="flex items-center justify-center gap-3 mt-6" data-id="element-113">
                <span className="text-2xl text-slate-500 line-through font-semibold" data-id="element-114">
                  $17 USD
                </span>
                <span className="text-6xl font-extrabold text-transparent bg-clip-text bg-accent-gradient" data-id="element-115">
                  $6.39
                </span>
                <span className="text-2xl text-slate-400 font-medium mt-4" data-id="element-116">
                  USD
                </span>
              </div>
              <div className="mt-3 inline-flex items-center px-3 py-1 rounded-full bg-emerald-500/15 text-emerald-400 text-sm font-semibold" data-id="element-117">
                🔥 62% de descuento — Oferta por tiempo limitado
              </div>
            </div>

            <div className="max-w-md mx-auto" data-id="element-118">
              <Button fullWidth href="https://pay.hotmart.com/B105004229W" className="text-xl py-5 mb-6" data-id="element-119">
                ¡QUIERO MI PRIMER EMPLEO EN DÓLARES!
              </Button>

              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-sm text-slate-400" data-id="element-120">
                <div className="flex items-center gap-2" data-id="element-121">
                  <Shield className="w-4 h-4 text-emerald-400" data-id="element-122" />
                  <span data-id="element-123">Pago único y seguro</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-124">
                  <Zap className="w-4 h-4 text-accent-400" data-id="element-125" />
                  <span data-id="element-126">Acceso inmediato</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-127">
                  <Clock className="w-4 h-4 text-blue-400" data-id="element-128" />
                  <span data-id="element-129">Acceso de por vida</span>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}